import { Typography, Stack, Icon, Box } from '@ace-clublabs/shared-component-library';
import { useContext, useState } from 'react';
import { MembershipAppStateContext } from '../MembershipAppState/MembershipAppState';
import { CurrentPayPlan, MembershipLevel } from '@ace-clublabs/common-membership-api-types';
import {
  capitalizeString,
  convertBillPlanToTerm,
  getMembershipTitle,
  getCostByMembershipLevel,
  getBaseCostByMembershipLevel,
  historyPushState,
} from '../../utils/helpers';
import { BenefitsPage } from '../../containers/BenefitsPage';
import { AddedInfoCard } from './AddedInfoCard';

export const BenefitLevelCard = () => {
  const { membershipInfo, sessionData } = useContext(MembershipAppStateContext);
  const { firstName, lastName, billPlan } = sessionData.formData;
  const membershipLevel = sessionData.formData.membershipLevel;
  const ml =
    membershipLevel == undefined ||
    membershipLevel == MembershipLevel.CLASSIC_RV ||
    membershipLevel == MembershipLevel.CLASSIC
      ? MembershipLevel.CLASSIC
      : membershipLevel == MembershipLevel.PLUS_RV || membershipLevel == MembershipLevel.PLUS
        ? MembershipLevel.PLUS
        : membershipLevel == MembershipLevel.PREMIER_RV || membershipLevel == MembershipLevel.PREMIER
          ? MembershipLevel.PREMIER
          : membershipLevel;
  const membershipTitle = getMembershipTitle(membershipLevel!) || 'Classic';
  const selectedTerm = convertBillPlanToTerm(sessionData.formData?.billPlan!);
  const primaryMemberName = capitalizeString(firstName!) + ' ' + capitalizeString(lastName!);
  const priceSuffix = billPlan == CurrentPayPlan.RECURRINGMONTHLY ? 'month' : 'year';
  const membershipBaseCost = getBaseCostByMembershipLevel(ml, membershipInfo!, selectedTerm);
  const priceAfterDiscount = getCostByMembershipLevel(membershipInfo!, membershipLevel!, selectedTerm, sessionData);

  const currentUrl = window.location.href;
  const urlSearchParams = new URL(currentUrl).searchParams;
  const isChangingMembershipLevelParam = urlSearchParams.get('isChangingMembershipLevel') === 'true';
  const [isChangingMembershipLevel, setIsChangingMembershipLevel] = useState(isChangingMembershipLevelParam);

  const showBenefitPage = () => {
    urlSearchParams.set('isChangingMembershipLevel', 'true');
    const newUrl = currentUrl.split('?')[0] + '?' + urlSearchParams.toString();
    historyPushState({ path: newUrl }, '', newUrl);
    setIsChangingMembershipLevel(true);
  };

  const closeBenefitsPage = () => {
    window.history.back();
  };

  return isChangingMembershipLevel ? (
    <BenefitsPage onContinue={closeBenefitsPage} isUpgrading={true} />
  ) : (
    <Box className="benefit-level-container">
      <Stack direction="column" className="benefit-level-info" width="100%">
        <Stack direction="row" alignItems="center" sx={{ gap: '0.5rem' }}>
          <Icon
            iconName="card-membership-duotone"
            sx={{ color: '#0C7A93', fontSize: '1.5rem' }}
            className="membership-card-icon"
          />
          <Typography className="benefit-level-title" variant="h6Medium">
            Benefit level
          </Typography>
        </Stack>
        <AddedInfoCard
          title={<>{membershipTitle} member</>}
          subtitle={primaryMemberName}
          content="Primary"
          editButtonOnClick={showBenefitPage}
          originalPrice={membershipBaseCost}
          priceAfterDiscount={priceAfterDiscount}
          priceSuffix={priceSuffix}
          className="primary"
        />
      </Stack>
    </Box>
  );
};
